import { Link } from "react-router-dom";
import React from "react";

export const home = {
  content: <Link to={`/home/Client/DashboardClient`}>Inicio</Link>,
};
export const configuration = {
  content: <Link to={`/home/Configuration`}>Configuración</Link>,
};
export const broker = {
  content: (
    <Link to={`/home/Configuration/Broker/DashboardBroker`}>
      Agentes comerciales
    </Link>
  ),
};
export const trackDocument = {
  content: (
    <Link to={`/home/TrackingDocuments`}>Reporte documentos electrónicos</Link>
  ),
};

export const client = {
  content: <Link to={`/home/Client/DashboardClient`}>Reporte clientes</Link>,
};

export const report = {
  content: <Link to={`/home/Report`}>Reportes</Link>,
};

export const sectionsConfiguration = [home, configuration];

export const sectionHome = [home];

export const sectionsInvoice = [home, trackDocument];

export const sectionBroker = [home, configuration, broker];

export const sectionClient = [home];

export const sectionReport = [home, report];
